export default __webpack_public_path__ + "static/media/image-grid-house.f6a35e41.png";